import React, { PropTypes } from 'react';
import { Checkbox } from 'material-ui';
import TypeControlledTextField from '../../../tc-ui/type-controlled-textfield.jsx';
import TwoColumnRow from '../../../tc-ui/two-column-row';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import StepperActions from '../../generic-components/stepper-actions';
import Select from 'react-select';
import { timeSelect15MinsInterval } from '../../../../utils/select-fields';

const EditCheckInOut = ({ onRequestClose, onTextFieldChange, contractId, saveSupplierInfoChanges, data, saving }) => {
  return (
    <div style={{ padding: '12px 8% 0 12%' }}>
      <TwoColumnRow
        outerContainerStyle={{ overflow: '', minHeight: '200px' }}
        leftColumnStyle={{ width: '50%' }}
        rightColumnStyle={{ width: '50%', display: 'inline-block' }}
        leftColumnContent={
          <div style={{ marginBottom: '30px' }}>
            CHECK-IN
            <Select
              style={{ fontSize: '14px', margin: '10px 0 12px 0', width: '75%', zIndex: '0' }}
              name="checkIn"
              options={timeSelect15MinsInterval.map(time => ({ label: time.label, value: time.label }))}
              value={data.checkIn}
              onChange={({ value }) => onTextFieldChange({ key: 'checkIn', value })}
              placeholder="Check-in"
              clearable={false}
              scrollMenuIntoView={false}
            />
            <Checkbox
              label={<small>EARLY CHECK-IN</small>}
              defaultChecked={data.earlyCheckInChecked}
              onCheck={() => onTextFieldChange({ key: 'earlyCheckInChecked', value: !data.earlyCheckInChecked })}
            />
            {
              data.earlyCheckInChecked ? (
                <div>
                  <div style={{ marginTop: '12px', width: '75%' }}>
                    <span style={{ position: 'relative', top: '20px' }}>From:</span>
                    <Select
                      style={{ fontSize: '14px', width: '70%', float: 'right', zIndex: '1' }}
                      name="earlyCheckIn"
                      options={timeSelect15MinsInterval.map(time => ({ label: time.label, value: time.label }))}
                      value={data.earlyCheckIn}
                      onChange={({ value }) => onTextFieldChange({ key: 'earlyCheckIn', value })}
                      placeholder="Early Check-in"
                      clearable={false}
                      scrollMenuIntoView={false}
                    />
                  </div>
                  <div style={{ marginTop: '12px', width: '75%' }}>
                    <span style={{ position: 'relative', top: '40px' }}>Cost Type:</span>
                    <Select
                      style={{ fontSize: '14px', width: '70%', zIndex: '0', float: 'right' }}
                      name="earlyCheckInCostType"
                      options={[
                        { value: '$', label: 'Fixed Cost' },
                        { value: '%', label: 'Percentage' },
                      ]}
                      value={data.earlyCheckInCostType || '$'}
                      onChange={({ value }) => onTextFieldChange({ key: 'earlyCheckInCostType', value })}
                      clearable={false}
                      scrollMenuIntoView={false}
                    />
                  </div>
                  <TypeControlledTextField
                    controlledType="number"
                    style={{ width: '75%', zIndex: '0' }}
                    floatingLabelText={data.earlyCheckInCostType || '$'}
                    floatingLabelStyle={{ fontSize: '14px' }}
                    value={data.earlyCheckInFee}
                    onChange={({ target: { value } }) => onTextFieldChange({ key: 'earlyCheckInFee', value })}
                  />
                  { data.earlyCheckInCostType === '%' ? (
                    <Select
                      style={{ fontSize: '11px', width: '75%', marginTop: '15px' }}
                      name="earlyCheckInPercentageType"
                      options={[
                        { value: 'of Nightly Rate', label: 'of Nightly Rate' },
                        { value: 'of Total Booking', label: 'of Total Booking' },
                      ]}
                      value={data.earlyCheckInPercentageType || 'of Nightly Rate'}
                      onChange={({ value }) => onTextFieldChange({ key: 'earlyCheckInPercentageType', value })}
                      clearable={false}
                      scrollMenuIntoView={false}
                    />
                  ) : undefined }
                </div>
              ) : undefined
            }
          </div>
        }
        rightColumnContent={
          <div style={{ marginBottom: '30px' }}>
            CHECK-OUT
            <Select
              style={{ fontSize: '14px', width: '75%', zIndex: '0', margin: '10px 0 12px 0' }}
              name="checkOut"
              options={timeSelect15MinsInterval.map(time => ({ label: time.label, value: time.label }))}
              value={data.checkOut}
              onChange={({ value }) => onTextFieldChange({ key: 'checkOut', value })}
              placeholder="Check-out"
              clearable={false}
              scrollMenuIntoView={false}
            />
            <Checkbox
              label={<small>LATE CHECK-OUT</small>}
              defaultChecked={data.lateCheckOutChecked}
              onCheck={() => onTextFieldChange({ key: 'lateCheckOutChecked', value: !data.lateCheckOutChecked })}
            />
            {
              data.lateCheckOutChecked ? (
                <div>
                  <div style={{ marginTop: '12px', width: '75%' }}>
                    <span style={{ position: 'relative', top: '20px' }}>Until:</span>
                    <Select
                      style={{ fontSize: '14px', width: '70%', float: 'right', zIndex: '1' }}
                      name="lateCheckOut"
                      options={timeSelect15MinsInterval.map(time => ({ label: time.label, value: time.label }))}
                      value={data.lateCheckOut}
                      onChange={({ value }) => onTextFieldChange({ key: 'lateCheckOut', value })}
                      placeholder="Late Check-out"
                      clearable={false}
                      scrollMenuIntoView={false}
                    />
                  </div>
                  <div style={{ marginTop: '12px', width: '75%' }}>
                    <span style={{ position: 'relative', top: '40px' }}>Cost Type:</span>
                    <Select
                      style={{ fontSize: '14px', width: '70%', zIndex: '0', float: 'right' }}
                      name="lateCheckOutCostType"
                      options={[
                        { value: '$', label: 'Fixed Cost' },
                        { value: '%', label: 'Percentage' },
                      ]}
                      value={data.lateCheckOutCostType || '$'}
                      onChange={({ value }) => onTextFieldChange({ key: 'lateCheckOutCostType', value })}
                      clearable={false}
                      scrollMenuIntoView={false}
                    />
                  </div>
                  <TypeControlledTextField
                    controlledType="number"
                    style={{ width: '75%' }}
                    floatingLabelText={data.lateCheckOutCostType || '$'}
                    floatingLabelStyle={{ fontSize: '14px', zIndex: '0' }}
                    value={data.lateCheckOutFee}
                    onChange={({ target: { value } }) => onTextFieldChange({ key: 'lateCheckOutFee', value })}
                  />
                  { data.lateCheckOutCostType === '%' ? (
                    <Select
                      style={{ fontSize: '11px', width: '75%', marginTop: '15px' }}
                      name="lateCheckOutPercentageType"
                      options={[
                        { value: 'of Nightly Rate', label: 'of Nightly Rate' },
                        { value: 'of Total Booking', label: 'of Total Booking' },
                      ]}
                      value={data.lateCheckOutPercentageType || 'of Nightly Rate'}
                      onChange={({ value }) => onTextFieldChange({ key: 'lateCheckOutPercentageType', value })}
                      clearable={false}
                      scrollMenuIntoView={false}
                    />
                  ) : undefined }
                </div>
              ) : undefined
            }
          </div>
        }
      />
      <StepperActions
        style={{ overflow: 'auto', marginTop: '12px' }}
        rightButtons={
        <div>
          <FlatButton
            label="Cancel"
            hoverColor="none"
            labelStyle={{ fontWeight: '600', marginRight: '15px' }}
            primary
            onTouchTap={onRequestClose}
          />
          <FlatButton
            label="Save"
            loader={saving}
            hoverColor="none"
            labelStyle={{ fontWeight: '600' }}
            onTouchTap={() => saveSupplierInfoChanges({ contractId, data, updateType: 'SAVED_CHECKIN_AND_CHECKOUT' })}
            secondary
          />
        </div>
        }
      />
    </div>
  );
};

const convertDateToTime = dateObj => {
  const hours = dateObj.getHours();
  const minutes = dateObj.getMinutes();
  const { amOrPm, lessThan12Hour } = (() => {
    if (hours === 0) return { amOrPm: 'am', lessThan12Hour: 12 };
    if (hours > 12) return { amOrPm: 'pm', lessThan12Hour: hours - 12 };
    return { amOrPm: 'am', lessThan12Hour: hours };
  })();
  const twoDigitsMinutes = `${minutes}`.length > 1 ? minutes : `0${minutes}`;
  return `${lessThan12Hour}:${twoDigitsMinutes}${amOrPm}`;
};

const convertTimeToDate = timeString => {
  if (!timeString) return timeString;
  const hours = timeString.split(':')[0];
  const minutes = timeString.split(':')[1].slice(0, 1) === '0' ? timeString.split(':')[1].slice(1, 2) : timeString.split(':')[1].slice(0, 2);
  const amOrPm = timeString.slice(-2);
  const hourIn23 = (() => {
    if (amOrPm === 'am') {
      if (hours === 12) return 0;
      return hours;
    }
    return hours + 12;
  })();
  return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), hourIn23, minutes);
};

EditCheckInOut.propTypes = {
  onRequestClose: PropTypes.func,
  onTextFieldChange: PropTypes.func,
  contractId: PropTypes.string,
  productId: PropTypes.string,
  saveSupplierInfoChanges: PropTypes.func,
  data: PropTypes.object,
  saving: PropTypes.bool,
};

export default EditCheckInOut;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/edit-checkin-checkout.jsx